import * as XLSX from 'xlsx-js-style';

export const exportData = (tableRef) => {
  if (!tableRef.current) return;

  const originalTable = tableRef.current;
  const clonedTable = originalTable.cloneNode(true);

  const colWidths = [];
  const rowHeights = [];
// const calculateWidth = Math.max(5, Math.ceil(cellValue.length * 0.5))
  const theadRows = clonedTable.querySelectorAll("thead tr");

  // ✅ First row fixed height
  if (theadRows[0]) rowHeights[0] = { hpx: 66 };
  if (theadRows[0]) {
    // rowHeights[0] = { hpx: 20 };
  
    theadRows[0].querySelectorAll("th").forEach((cell, colIndex) => {
      const text = cell.textContent.replace(/\s+/g, ' ').trim(); // Clean extra space
      if (text !== "") {
        const estimatedWidth = Math.max(3, Math.ceil(text.length ));
        if (!colWidths[colIndex] || estimatedWidth > colWidths[colIndex].wch) {
          colWidths[colIndex] = { wch: estimatedWidth };
        }
      }
    });
  }
  // ✅ Use 2nd header row (index 1) for column width
  if (theadRows[1]) {
    // theadRows[1].querySelectorAll("th").forEach((cell, colIndex) => {
    //   const text = cell.textContent.replace(/\s+/g, ' ').trim(); // ✅ remove extra spaces
    //   if (text !== "") {
    //     const width = Math.max(5, Math.ceil(text.length * 1.2));
    //     // const width = Math.min(30, Math.max(5, Math.ceil(text.length * 1.2)));

    //     colWidths[colIndex] = { wch: width };
    //   }
    // });
    let colIndex = 0;

  theadRows[1].querySelectorAll("th").forEach((cell) => {
    const colspan = parseInt(cell.getAttribute("colspan") || "1", 10);
    const text = cell.textContent.replace(/\s+/g, ' ').trim(); // ✅ remove extra spaces

    const estimatedWidth = text !== ""
      ? Math.max(2, Math.ceil(text.length * 1)) // or Math.min(30, ...)
      : 2; // very narrow width for blank headers
console.log("estimatedWidthestimatedWidth",estimatedWidth,'texttext',text);

    // Assign width to spanned columns
    for (let i = 0; i < colspan; i++) {
      colWidths[colIndex] = { wch: i === 0 ? estimatedWidth : 2 }; // first gets real width
      colIndex++;
    }
  });

    // ✅ DO NOT set rowHeights[1] so Excel auto adjusts height
  }

  clonedTable.querySelectorAll("td, th").forEach((cell) => {
    const input = cell.querySelector("input");
    let cellValue = "";
  
    if (input && input.type === "checkbox") {
      let labelText = "";
      Array.from(cell.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {
          labelText += node.textContent.trim() + " ";
        } else if (
          node.nodeType === Node.ELEMENT_NODE &&
          !["input", "span", "label"].includes(node.tagName.toLowerCase())
        ) {
          labelText += node.textContent.trim() + " ";
        }
      });
      labelText = labelText.replace(/Checked|Unchecked/g, "").trim();
      const checkboxState = input.checked ? "✓" : "";
      cellValue = `${checkboxState} ${labelText}`.trim();
    } else if (input) {
      cellValue = input.value.trim();
    } else {
      // ✅ Clean extra spaces, tabs, newlines
      cellValue = cell.textContent.replace(/\s+/g, " ").trim();
    }
  
    const isTd = cell.tagName.toLowerCase() === "td";
    const isTh = cell.tagName.toLowerCase() === "th";
    const rowIdx = cell.closest("tr").rowIndex;
  
    // ✅ Apply clean content back to all cells (td/th)
    cell.textContent = cellValue;
  
    // ✅ Width calculation only for <td>
    if (isTd) {
      const parts = cellValue.split("->");
      cell.textContent = parts.length > 1 ? parts[1].trim() : cellValue;

      const colIndex = Array.from(cell.parentNode.children).indexOf(cell);
      const estimatedWidth = Math.max(5, Math.ceil(cellValue.length * 1));
      if (!colWidths[colIndex] || estimatedWidth > colWidths[colIndex].wch) {
        colWidths[colIndex] = { wch: estimatedWidth };
      }
    }
  
    // ✅ Apply fixed height only to first <thead> row
    if (isTh && rowIdx === 0 && !rowHeights[rowIdx]) {
      rowHeights[rowIdx] = { hpx: 66 };
    }
  });
  
  
  

  const ws = XLSX.utils.table_to_sheet(clonedTable, { raw: true });

  if (colWidths.length > 0) ws["!cols"] = colWidths;
  if (rowHeights.length > 0) ws["!rows"] = rowHeights;

  // Apply styles
  const rows = clonedTable.querySelectorAll("tr");
  let sheetRow = 0;

  rows.forEach((row) => {
    const cells = row.querySelectorAll("th, td");
    let sheetCol = 0;

    cells.forEach((cell) => {
      while (ws[XLSX.utils.encode_cell({ r: sheetRow, c: sheetCol })] === undefined) {
        sheetCol++;
      }

      const cellRef = XLSX.utils.encode_cell({ r: sheetRow, c: sheetCol });
      const cellValue = ws[cellRef];
      if (!cellValue) return;

      const isHeader = cell.tagName.toLowerCase() === "th";
      const style = {
        font: { bold: isHeader },
        alignment: {
          wrapText: true,
          vertical: "center",
          horizontal: "center",
        },
      };

      if (cell.classList.contains("sale-highlight")) {
        style.fill = {
          patternType: "solid",
          fgColor: { rgb: "FFFF00" },
        };
      }

      ws[cellRef].s = style;

      const colspan = parseInt(cell.getAttribute("colspan") || "1", 10);
      sheetCol += colspan;
    });

    sheetRow++;
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Exported Data");
  XLSX.writeFile(wb, "direct_inout_table.xlsx");
};
